<ng-container *ngIf="state?.style !== null; else elseTemplate">
  <button
    type="button"
    class="kng-btn kng-btn--{{ state.style }} kng-btn--{{ state.size }}"
    [disabled]="state.disabled"
    (click)="handleClick()"
    tabindex="0"
  >
    <img *ngIf="state.icon.iconPath" [src]="state.icon.iconPath" [alt]="state.icon.altText" class="icon--{{ state.position }}">
    <div>{{ state.label }}</div>
  </button>
</ng-container>
<ng-template #elseTemplate></ng-template>
